<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">Manage Index</div>
    </div>
    <div class="col-md-12 well-content">
        <div class="panel panel-default">
            <div class="panel-heading">Information</div>
            <div class="panel-body">
                <div class="row">
                    <div class="form-group">
                        <label class="col-md-2 control-label" for="dbDocs">Database Documents</label>
                        <span name="dbDocs" class="col-md-10">{{ Documents | number: "1.0-0" }}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group">
                        <label class="col-md-2 control-label" for="indexDocs">Index Documents</label>
                        <span name="indexDocs" class="col-md-10">{{
                            Reindexing ? Status : (IndexedDocuments | number: "1.0-0")
                        }}</span>
                    </div>
                </div>
                @if (Reindexing) {
                    <div class="row">
                        <div class="form-group">
                            <label class="col-md-2 control-label" for="progress">Progress</label>
                            <span name="progress" class="col-md-6">
                                <nz-progress [nzPercent]="PercentComplete" nzStatus="active"> </nz-progress>
                            </span>
                        </div>
                    </div>
                }
                <button
                    [disabled]="Reindexing"
                    type="submit"
                    id="rebuildButton"
                    class="btn btn-default"
                    style="width: 100%"
                    [style.background-color]="Reindexing ? 'white' : ''"
                    [innerHTML]="
                        Reindexing
                            ? `Reindexing <img style='padding-top: 3px' height='17' src='assets/ajax-loader.gif'>`
                            : 'Rebuild Index'
                    "
                    (click)="RebuildIndex()"></button>
            </div>
        </div>
    </div>
</div>
